// ABOUTME: Reusable rights selector for OpenAPI keys, grouped by resource.
// ABOUTME: Used by both the create modal and the edit sidepanel.
import { Box } from "@mui/material";
import { useTranslation } from "react-i18next";
import SettingGroup from "../../theme/settings/SettingGroup";
import BoolAuthSetting from "../Settings/BoolAuthSetting";
import { OPENAPI_RIGHTS_GROUPS } from "../../../newapi/openapikey/openapikeySlice";

const rightLabelKey = (right) => `right_${right.replaceAll(':', '_')}`;

const OpenapikeyRightsCheckboxGrid = ({ value = [], onChange, disabled = false }) => {
    const { t } = useTranslation();

    const toggle = (right, next) => {
        if (disabled) return;
        const isOn = value.includes(right);
        if (next && !isOn) {
            onChange([...value, right]);
        } else if (!next && isOn) {
            onChange(value.filter(r => r !== right));
        }
    };

    return (
        <Box
            sx={{
                display: "grid",
                gridTemplateColumns: "1fr 1fr",
                gap: "24px 80px",
                "@media screen and (max-width: 63.9375em)": {
                    py: 3,
                    gridTemplateColumns: "1fr",
                    gap: 4,
                },
            }}
        >
            {OPENAPI_RIGHTS_GROUPS.map(({ group, rights }) => (
                <Box key={group}>
                    <SettingGroup title={t(group)}>
                        {rights.map(right => (
                            <BoolAuthSetting
                                key={right}
                                title={t(rightLabelKey(right))}
                                val={value.includes(right)}
                                disabled={disabled}
                                onChange={(next) => toggle(right, next)}
                            />
                        ))}
                    </SettingGroup>
                </Box>
            ))}
        </Box>
    );
};

export default OpenapikeyRightsCheckboxGrid;
